import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u8BF7\u63D0\u4F9B\u4E00\u4E2A\u5C3D\u53EF\u80FD\u7CBE\u7B80\u7684\u94FE\u63A5\u6216\u662F GitHub \u4ED3\u5E93\u7684\u94FE\u63A5\u3002 ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "#repro-modal"
    }
  }, "\u4EC0\u4E48\u662F\u6700\u5C0F\u5316\u91CD\u73B0\uFF0C\u4E3A\u4EC0\u4E48\u8FD9\u662F\u5FC5\u9700\u7684\uFF1F")));
});